import React, { useEffect, useState } from 'react'
import { workerJobBank } from '../../../services/workerJobBank'
import { useI18n } from '../../../i18n/I18nContext'

export const JobBankPublicationPanel: React.FC = () => {
  const { t } = useI18n()
  const [enabled, setEnabled] = useState<boolean | null>(null)
  const [intelligence,setIntelligence]=useState({matchingEnabled:true,careerEnabled:true,alertsEnabled:true})
  const [busy, setBusy] = useState(false), [error, setError] = useState('')
  useEffect(() => {
    let live = true
    workerJobBank.publicationPolicy().then(value => { if (live) {setEnabled(value.enabled);setIntelligence({matchingEnabled:value.matchingEnabled!==false,careerEnabled:value.careerEnabled!==false,alertsEnabled:value.alertsEnabled!==false})} }).catch(error => {
      if (live && error?.response?.status !== 403) setError(t('Publication settings could not be loaded.'))
    })
    return () => { live = false }
  }, [t])
  if (enabled === null && !error) return null
  return <section className="admin-card">
    <h3>{t('Personal Worker JobBank publication')}</h3>
    <p>{t('Workers can discover approved public opportunities without employer membership. Enable public discovery individually for each authorized source.')}</p>
    {error ? <p role="alert">{error}</p> : null}
    {enabled!==null?(['matchingEnabled','careerEnabled','alertsEnabled'] as const).map(key=><label key={key}><input type="checkbox" checked={intelligence[key]} disabled={busy} onChange={async event=>{setBusy(true);try{setIntelligence(await workerJobBank.setIntelligencePolicy({[key]:event.target.checked}))}catch{setError(t('Settings could not be saved.'))}finally{setBusy(false)}}}/>{t(key==='matchingEnabled'?'Personal skill matching':key==='careerEnabled'?'Career skill focus in Learning':'Opt-in personal job alerts')}</label>):null}
    {enabled !== null ? <label><input type="checkbox" checked={enabled} disabled={busy} onChange={async event => {
      const next = event.target.checked; setBusy(true); setError('')
      try { setEnabled((await workerJobBank.setPublicationPolicy(next)).enabled) }
      catch { setError(t('Publication settings could not be saved.')) }
      finally { setBusy(false) }
    }} />{t('Publish approved opportunities to workers')}</label> : null}
  </section>
}
